import { faChevronDown } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Accordion, AccordionDetails, AccordionSummary, Typography, Avatar,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import BidCard from './BidCard';
import { EmployeeBidProfileColumnNames } from '../../../Enums';
/**
     * @param {{
     *      profiles : EmployeeBidProfile.IEmployeeBidProfile[],
     *      employeeBidProfileColumn:EmployeeBidProfileColumn
     * }} param0
     * @returns
     */
const BidsSectionMobile = ({ profiles, employeeBidProfileColumn }) => {
    const { t } = useTranslation('shiftBidding', { keyPrefix: 'common.employeeBidProfileColumnStatus' });
    return (
        <Accordion
            elevation={0}
            square
            className="bid-profile-accordion-container"
            disabled={profiles.length === 0}
        >
            <AccordionSummary
                className="accordion"
                expandIcon={(
                    <FontAwesomeIcon
                        icon={faChevronDown}
                    />
                )}
                aria-controls={`${EmployeeBidProfileColumnNames[employeeBidProfileColumn]}-panel`}
                id={`${EmployeeBidProfileColumnNames[employeeBidProfileColumn]}-panel`}
            >

                <Typography
                    variant="h6"
                    className="status-label"
                >
                    {t(`${EmployeeBidProfileColumnNames[employeeBidProfileColumn].toLowerCase()}`)}
                </Typography>
                <Avatar className="bid-profile-count-avatar">{profiles.length}</Avatar>
            </AccordionSummary>
            <AccordionDetails>
                <div
                    className="bid-profiles-list"
                >
                    {profiles.map((profile) => (
                        <BidCard
                            key={profile.profileId}
                            profile={profile}
                            employeeBidProfileColumn={employeeBidProfileColumn}
                        />
                    ))}
                </div>
            </AccordionDetails>
        </Accordion>
    );
};
export default BidsSectionMobile;
